export const APP_JSON = `
{
  "name": "MBB",
  "minimumDeviceAndroidVersion": 19,
  "screens": [
    {
      "id": "123",
      "name": "Splash"
    },
    {
      "id": "125",
      "name": "Watchlist"
    },
    {
      "id": "126",
      "name": "Shopping Cart"
    }
  ],
  "globals": [
    {
      "id": 1,
      "title": "Stream the current app user login state",
      "spec": "SPEC",
      "flows": [],
      "signalOutput": [
        {
          "id": 1,
          "name": "Logged Out"
        },
        {
          "id": 2,
          "name": "Logged In",
          "attributes": [
            {
              "name": "Optional App User",
              "type": "(User)"
            }
          ]
        }
      ],
      "tags": ["user", "appuser", "login", "logged out", "logged in"]
    },
    {
      "id": 2,
      "title": "Stream the current state of the Shopping Cart",
      "spec": "Turn the test-cart.json I sent you into data models and simply emit it for now to mock stream. FYI: For an empty cart, optional.absent is emitted.",
      "flows": [],
      "signalOutput": [
        {
          "id": 1,
          "name": "Loading"
        },
        {
          "id": 2,
          "name": "Loaded",
          "attributes": [
            {
              "name": "Optional Cart",
              "type": "(Cart)"
            }
          ]
        }
      ],
      "tags": ["cart", "shoppable"]
    },
    {
      "id": 3,
      "title": "Save Selected Gender",
      "spec": "Set the current gender to the passed value and save it for future launches.",
      "parameters": [
        {
          "name": "New Gender",
          "type": "Gender"
        }
      ],
      "signalOutput": [
        {
          "id": 1,
          "name": "Complete"
        }
      ],
      "tags": ["gender"]
    },
    {
      "id": 4,
      "title": "Load Selected Gender",
      "spec": "Load a maybe previously saved gender.",
      "typesOutput": [
        {
          "id": 1,
          "name": "Gender if available",
          "type": "Gender?"
        }
      ],
      "tags": ["gender"]
    }
  ]
}
`;



// WEBPACK FOOTER //
// ./src/app_src.js